import dataComputedRouter from './moudels/dataComputedRouter'
import dataPretreatmentRouter from './moudels/dataPretreatmentRouter'

const bonusSchemeRouter = [].concat(dataComputedRouter, dataPretreatmentRouter)
export default bonusSchemeRouter
